function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.33,
    y: 388.83,
    width: 23.25,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.57,
    y: 394.26,
    width: 110.43,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.5,
    y: 394.39,
    width: 10.83,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 391.39,
    width: 37.56,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.67,
    y: 388.83,
    width: 21.98,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.65,
    y: 391.39,
    width: 18.19,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.56,
    y: 73.55,
    width: 75.57,
    height: 131.57,
    transform: "translate(722.7 278.67) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.48,
    y: 73.55,
    width: 75.57,
    height: 131.57,
    transform: "translate(714.54 278.67) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.66,
    y: 108.88,
    width: 119.22,
    height: 60.91,
    transform: "translate(496.6 -217.93) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.75,
    y: 137.79,
    width: 119.22,
    height: 3.09,
    transform: "translate(467.69 -189.02) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.51,
    y: 161.89,
    width: 69.51,
    height: 8.29,
    transform: "translate(714.54 332.06) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.14,
    y: 73.55,
    width: 75.57,
    height: 131.57,
    transform: "translate(465.85 278.67) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.06,
    y: 73.55,
    width: 75.57,
    height: 131.57,
    transform: "translate(457.69 278.67) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.24,
    y: 108.88,
    width: 119.22,
    height: 60.91,
    transform: "translate(368.18 -89.51) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.32,
    y: 137.79,
    width: 119.22,
    height: 3.09,
    transform: "translate(339.26 -60.6) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.09,
    y: 161.89,
    width: 69.51,
    height: 8.29,
    transform: "translate(457.69 332.06) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.72,
    y: 73.55,
    width: 75.57,
    height: 131.57,
    transform: "translate(209.01 278.67) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.63,
    y: 73.55,
    width: 75.57,
    height: 131.57,
    transform: "translate(200.84 278.67) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.81,
    y: 108.88,
    width: 119.22,
    height: 60.91,
    transform: "translate(239.75 38.91) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 137.79,
    width: 119.22,
    height: 3.09,
    transform: "translate(210.84 67.83) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.66,
    y: 161.89,
    width: 69.51,
    height: 8.29,
    transform: "translate(200.84 332.06) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,286.52c-13.63,1.88-22.06-27.74,8-52.82C146.43,262.73,163.78,283.24,140,286.52Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,325.31c-19.76-13.85-6.24-62.24,54.91-58.73C158.47,302.2,164.46,349.45,130,325.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,325c13.13-14.14-5.56-49.73-52.81-36.73C110.85,311.67,114.09,349.64,137,325Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.14,304.36c-4.54-5.53-9.9-11.75-8.6-18.33s4.55-11.47,2-18.47c-3.1-8.4-2.5-18.42,2.74-17.58s11.11,7,11,15.11c-.09,7.88,5,10.4,9.9,14.59S143.81,290,144.68,296c1.52,9.53,13.87,7.73,17.15,16,3.39,8-3.37,18.65-14.18,21.1s-18.51,4-25.88-4.46C114.28,319.73,126.86,312.28,120.14,304.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.33 382.4 116.72 382.4 113.66 327.08 160.39 327.08 157.33 382.4",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.63,
    y: 325.95,
    width: 52.79,
    height: 5.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.74,
    y: 256.42,
    width: 27.32,
    height: 118.47,
    transform: "translate(820.8 631.31) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.66,
    y: 374.89,
    width: 236.16,
    height: 7.51,
    transform: "translate(601.47 757.29) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.41,
    y: 256.42,
    width: 219.33,
    height: 118.47,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.15,
    y: 271,
    width: 197.85,
    height: 38.86,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.15,
    y: 321.45,
    width: 197.85,
    height: 38.86,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,293.09H348.62a2.67,2.67,0,0,0,2.66-2.66h0a2.67,2.67,0,0,0-2.66-2.67H225.53a2.67,2.67,0,0,0-2.66,2.67h0A2.67,2.67,0,0,0,225.53,293.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,343.54H348.62a2.67,2.67,0,0,0,2.66-2.66h0a2.67,2.67,0,0,0-2.66-2.66H225.53a2.67,2.67,0,0,0-2.66,2.66h0A2.67,2.67,0,0,0,225.53,343.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.19,239.13s31.3,29.66,49.88-.12c0,0-4.94-9.57-10.15-10.39s-5.42,8.28-10,5.47-9.93-12.42-12.85-7.29-6.93-2.18-11.3-2.6S336.19,239.13,336.19,239.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.06,237.08s-.68,19.34-27.06,19.34-27.06-19.34-27.06-19.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.61,227H269.8v29.42H225.2A29.42,29.42,0,0,1,254.61,227Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.8,
    y: 227,
    width: 14.01,
    height: 29.42,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218,197.76l-.66,1c-.2.29-.41.55-.61.82-.41.54-.84,1-1.27,1.55-.87,1-1.75,2-2.69,2.88a55.25,55.25,0,0,1-6,5,52.65,52.65,0,0,1-6.65,4.08c-1.17.57-2.33,1.16-3.54,1.64l-1.81.72-.51.19c-.28.09-.54.19-.85.26a7.1,7.1,0,0,1-1.85.21,7.47,7.47,0,0,1-3.41-.85,9.89,9.89,0,0,1-2.31-1.67,17.18,17.18,0,0,1-2.79-3.6,38,38,0,0,1-3.19-7.2,79.23,79.23,0,0,1-3.36-14.51l4.18-.92c.76,2.19,1.54,4.45,2.4,6.63s1.72,4.35,2.72,6.41a37.13,37.13,0,0,0,3.24,5.69,9.69,9.69,0,0,0,1.77,2,2.39,2.39,0,0,0,.65.38c.14,0,.13,0,.06,0l-.07,0s0,0,0,0l.33-.16,1.49-.72c1-.48,1.95-1,2.91-1.58a59.85,59.85,0,0,0,5.48-3.71,52.84,52.84,0,0,0,4.93-4.4c.78-.76,1.52-1.57,2.23-2.39.35-.41.7-.82,1-1.23l.48-.61.39-.52Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.89 197.33 210.96 209.49 207.29 211.78 201.59 200.75 205.89 197.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.24,187.09c-8.27-.11-16.67,10.36-16.88,10.62l6.54,15.38s14.55-11.81,15.28-16.43C225.94,191.85,225.48,187.16,220.24,187.09Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.24,187.09c-8.27-.11-16.67,10.36-16.88,10.62l6.54,15.38s14.55-11.81,15.28-16.43C225.94,191.85,225.48,187.16,220.24,187.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,185.77l-5.72-4.45-1.16,8.76s5.56,2.18,8.52.29l-.08-1.6A4.07,4.07,0,0,0,180,185.77Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.66 180.88 167.02 187.53 173.15 190.08 174.31 181.32 166.66 180.88",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,185.06l8.84-2.21-6.18-6.31s-5.73,2.34-4.33,7.34Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.23 181.28 304.5 174.34 294.61 176.54 300.79 182.85 305.23 181.28",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.17 407.47 254.94 408.26 248.07 388.84 256.3 388.04 263.17 407.47",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.27 366.64 345.21 372.52 329.63 360.36 335.7 354.48 351.27 366.64",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.46,371.38l4.66-8.27a.67.67,0,0,1,.83-.3l7.08,2.74a1.36,1.36,0,0,1,.64,1.92c-1.67,2.86-2.62,4.15-4.67,7.79-1.26,2.24-3.72,7.37-5.46,10.46s-4.89,1.53-4.44.09c2-6.47,1.66-10.08,1.12-12.94A2.19,2.19,0,0,1,343.46,371.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.3,405.74h10a.84.84,0,0,1,.79.61l2.18,7.93a1.24,1.24,0,0,1-1.22,1.59c-3.51-.06-5.22-.27-9.63-.27-2.71,0-11.54.29-15.29.29s-4.43-3.71-2.91-4c6.8-1.51,12.54-3.58,14.63-5.56A2.06,2.06,0,0,1,253.3,405.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.08 388.84 251.61 398.86 260.13 398.86 256.31 388.04 248.08 388.84",
    style: {
      fill: "#a76755"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.71 354.48 329.64 360.37 337.67 366.63 343.74 360.75 335.71 354.48",
    style: {
      fill: "#a76755"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.19,189.76s-3.4,2.59,19.51,47.3l32.66-10.55c-4.84-13.11-7.5-21.3-10-50.63A101.07,101.07,0,0,0,240,178.53a118.37,118.37,0,0,0-14.83,4.79C218.93,186,212.19,189.76,212.19,189.76Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.19,189.76s-3.4,2.59,19.51,47.3l32.66-10.55c-4.84-13.11-7.5-21.3-10-50.63A101.07,101.07,0,0,0,240,178.53a118.37,118.37,0,0,0-14.83,4.79C218.93,186,212.19,189.76,212.19,189.76Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09,162.3c.6,5.08,2.49,14.12,6.86,16.23,0,0,.25,5.26-8.61,8.12-9.75,3.15-6.22-3.33-6.22-3.33,4.91-3,3.49-6.9,1.37-10.3Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.7,187.34c2.41-1.25,5.48-2.77,8.42-4A109.46,109.46,0,0,1,240,178.53c2.85-.78,5.73-1.36,8.16-1.77.23.68-.46,2.44-2.15,4.87-5.35,4.44-16.76,10.21-25.17,10C217.16,190.26,216.24,188.81,216.7,187.34Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,181.63a60.83,60.83,0,0,1-12.88,12.75,63.72,63.72,0,0,1-12.29-2.75C229.2,191.84,240.61,186.07,246,181.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.4,166.67,226.49,173a15.64,15.64,0,0,1,1.31,2.49c1.94-.95,4.41-3.76,3.94-6A9,9,0,0,0,230.4,166.67Z",
    style: {
      fill: "#a76755"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.07,152.92c.5,8.37.9,11.9-2.78,16.68-5.53,7.18-15.92,6-18.92-2.08-2.69-7.25-3.06-19.72,4.67-24A11.44,11.44,0,0,1,235.07,152.92Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.53,
    cy: 134.49,
    r: 15.44,
    transform: "translate(52.96 335.32) rotate(-77.19)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.69,141.2c3.18,2.1,4.76,5.32,3.53,7.19s-4.81,1.69-8-.41-4.76-5.32-3.53-7.19S229.5,139.1,232.69,141.2Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.69,141.2c3.18,2.1,4.76,5.32,3.53,7.19s-4.81,1.69-8-.41-4.76-5.32-3.53-7.19S229.5,139.1,232.69,141.2Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,158.63c.83-1.92-2.06-7.62-1.44-9.75-1.66-1.55-18.49,3.93-17.13-.07,1.3-3.84,5.4-8.93,14.76-6.8,10,2.28,10.87,10.93,9.75,13.69s-2.71,5.63-2.71,5.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.27,160.26a6.16,6.16,0,0,1-1.72,4.35c-1.51,1.53-3.33.43-3.8-1.55-.43-1.78-.15-4.73,1.79-5.51A2.74,2.74,0,0,1,237.27,160.26Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.7,237.06s-15.14,73.84-6.7,98.19c8.78,25.33,23.07,60.69,23.07,60.69l13.35-.76s-11-44.68-13.71-64.86C244,302.5,259.89,228,259.89,228Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.7,237.06s-15.14,73.84-6.7,98.19c8.78,25.33,23.07,60.69,23.07,60.69l13.35-.76s-11-44.68-13.71-64.86C244,302.5,259.89,228,259.89,228Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.47 395.5 247.02 396.39 244.54 390.31 261.58 388.54 262.47 395.5",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.47 395.5 247.02 396.39 244.54 390.31 261.58 388.54 262.47 395.5",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.71,242.74c-2.32,8.58-.38,21.44,4,30.46,1.07-7,2.21-13.78,3.29-19.85C252.75,249,250.27,245.14,247.71,242.74Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.71,242.74c-2.32,8.58-.38,21.44,4,30.46,1.07-7,2.21-13.78,3.29-19.85C252.75,249,250.27,245.14,247.71,242.74Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.32,234.27S262.8,288,277.69,317.5c12,23.86,56.53,48.83,56.53,48.83l8-8.48s-33.28-29.55-41.58-45.73c-26.56-51.79-21.1-74.41-36.26-85.61Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.32,234.27S262.8,288,277.69,317.5c12,23.86,56.53,48.83,56.53,48.83l8-8.48s-33.28-29.55-41.58-45.73c-26.56-51.79-21.1-74.41-36.26-85.61Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.71 356.64 332.71 368.33 325.75 364.67 338.42 351.75 343.71 356.64",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.71 356.64 332.71 368.33 325.75 364.67 338.42 351.75 343.71 356.64",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.23,224.44l2.41,2.45c.19.19,0,.51-.38.63l-34.25,11c-.3.1-.59,0-.67-.15l-1.23-2.82c-.09-.2.11-.45.43-.56l33.07-10.67A.64.64,0,0,1,264.23,224.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,229.57l.88-.28c.18-.06.28-.2.24-.3l-1.64-3.67c0-.1-.24-.14-.41-.09l-.89.29c-.17,0-.28.19-.23.3l1.64,3.66C260.62,229.59,260.8,229.63,261,229.57Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,229.57l.88-.28c.18-.06.28-.2.24-.3l-1.64-3.67c0-.1-.24-.14-.41-.09l-.89.29c-.17,0-.28.19-.23.3l1.64,3.66C260.62,229.59,260.8,229.63,261,229.57Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.6,238.09l.89-.29c.17-.06.28-.19.23-.3l-1.64-3.66c-.05-.11-.23-.15-.41-.09l-.89.28c-.17.06-.28.19-.23.3l1.64,3.66C234.24,238.1,234.42,238.14,234.6,238.09Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.6,238.09l.89-.29c.17-.06.28-.19.23-.3l-1.64-3.66c-.05-.11-.23-.15-.41-.09l-.89.28c-.17.06-.28.19-.23.3l1.64,3.66C234.24,238.1,234.42,238.14,234.6,238.09Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,233.83l.88-.29c.18,0,.29-.19.24-.3l-1.64-3.66c-.05-.11-.24-.15-.41-.09l-.89.29c-.17.05-.28.19-.23.29l1.64,3.67A.35.35,0,0,0,247.79,233.83Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,233.83l.88-.29c.18,0,.29-.19.24-.3l-1.64-3.66c-.05-.11-.24-.15-.41-.09l-.89.29c-.17.05-.28.19-.23.29l1.64,3.67A.35.35,0,0,0,247.79,233.83Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.75,156.78c.08.67-.21,1.27-.65,1.32s-.87-.45-.95-1.13.21-1.27.65-1.32S222.67,156.1,222.75,156.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.1,157.71c.09.68-.21,1.27-.65,1.32s-.87-.45-.95-1.12.21-1.27.65-1.33S215,157,215.1,157.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.35,156.6l-1.68-.27S213.66,157.5,214.35,156.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.27,158.63a18.39,18.39,0,0,1-1.89,4.61,3,3,0,0,0,2.47.16Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.53,165.77a.2.2,0,0,1-.2-.17.22.22,0,0,1,.18-.23,5.4,5.4,0,0,0,4.11-2.62.2.2,0,0,1,.27-.1.2.2,0,0,1,.09.27,5.71,5.71,0,0,1-4.42,2.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.7,154.38a.4.4,0,0,1-.26-.1,3.15,3.15,0,0,0-2.79-.77.4.4,0,0,1-.5-.28.39.39,0,0,1,.28-.49,4,4,0,0,1,3.53.93.4.4,0,0,1,0,.57A.41.41,0,0,1,223.7,154.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.15,154.61a.39.39,0,0,1-.18,0,.41.41,0,0,1-.17-.54,4,4,0,0,1,2.9-2.21.4.4,0,0,1,.44.35.4.4,0,0,1-.35.45h0a3.15,3.15,0,0,0-2.28,1.77A.4.4,0,0,1,211.15,154.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,183.69l.38.48.47.57c.32.38.65.77,1,1.15.69.77,1.41,1.53,2.18,2.25a54.23,54.23,0,0,0,4.77,4.16,63.47,63.47,0,0,0,5.27,3.59c.91.55,1.84,1.07,2.78,1.58l1.43.73.69.35c.17.08.34.16.5.22a4.29,4.29,0,0,0,1.61.33,2.54,2.54,0,0,0,1.4-.52,11.05,11.05,0,0,0,3.09-4.12,34.39,34.39,0,0,0,2.23-6,64.69,64.69,0,0,0,1.53-6.4l4.27.27a43.5,43.5,0,0,1-2.08,14.52,20.53,20.53,0,0,1-1.65,3.68,13.73,13.73,0,0,1-2.84,3.55,10,10,0,0,1-4.79,2.35,10.83,10.83,0,0,1-5.18-.36c-.39-.11-.75-.25-1.12-.39l-.87-.36-1.7-.71c-1.13-.51-2.24-1-3.33-1.62a55.43,55.43,0,0,1-6.31-3.89,57.64,57.64,0,0,1-5.75-4.74c-.9-.86-1.77-1.77-2.62-2.71-.42-.48-.84-1-1.24-1.46l-.61-.79c-.21-.28-.37-.5-.65-.9Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.09 188.96 261.83 199.47 258.78 196.59 264.56 186.06 268.09 188.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.4,175.88c3.6-.06,12.34,10.26,12.34,10.26l-7.6,13.23s-9.68-8.53-9.67-13.2C249.48,181.3,250.3,176,254.4,175.88Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.4,175.88c3.6-.06,12.34,10.26,12.34,10.26l-7.6,13.23s-9.68-8.53-9.67-13.2C249.48,181.3,250.3,176,254.4,175.88Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.82,375.87a1.27,1.27,0,0,1-.76-.29.66.66,0,0,1-.29-.62c.09-1.08,2.8-2.5,3.1-2.66a.2.2,0,0,1,.22,0,.21.21,0,0,1,.07.21c-.31,1.08-1,2.94-2,3.27A1,1,0,0,1,341.82,375.87Zm1.81-3c-1.06.6-2.41,1.54-2.46,2.1a.26.26,0,0,0,.14.27.72.72,0,0,0,.72.17C342.58,375.25,343.16,374.31,343.63,372.89Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.45,373.25a2,2,0,0,1-1.25-.31.7.7,0,0,1-.16-.86,1,1,0,0,1,.65-.61c1.16-.39,3.28.78,3.37.83a.21.21,0,0,1,.11.18.21.21,0,0,1-.1.17A6,6,0,0,1,341.45,373.25Zm-.21-1.46a1.37,1.37,0,0,0-.42.06.65.65,0,0,0-.41.38c-.1.24,0,.34,0,.41.45.38,2.11.22,3.06-.17A6.1,6.1,0,0,0,341.24,371.79Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.86,407.4a3.32,3.32,0,0,1-2-.47,1.25,1.25,0,0,1-.51-1,.59.59,0,0,1,.25-.55c.91-.62,4.33.94,5,1.25a.2.2,0,0,1,.11.21.19.19,0,0,1-.15.17A13.53,13.53,0,0,1,248.86,407.4Zm-1.6-1.73a.69.69,0,0,0-.39.08.19.19,0,0,0-.08.19.86.86,0,0,0,.35.67c.79.6,2.67.37,3.77.17A12.71,12.71,0,0,0,247.26,405.67Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.56,407.05h-.08c-1.13-.46-3.41-2.29-3.28-3.24,0-.21.16-.47.68-.53,2-.26,2.84,3.39,2.87,3.54a.21.21,0,0,1-.06.2A.22.22,0,0,1,251.56,407.05Zm-2.5-3.39h-.13c-.21,0-.33.09-.34.19-.07.54,1.5,2,2.66,2.62C251,405.61,250.26,403.66,249.06,403.66Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,155.66l-1.68-.27S221.31,156.56,222,155.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.44,85.78c-1.77,2.22-11.52,4.83-19.27,4.11-2.67,17.52,6.66,37.69,6.66,37.69s20.25-2.41,20.75-10.75S159.44,85.78,159.44,85.78Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.44,85.78c-1.77,2.22-11.52,4.83-19.27,4.11-2.67,17.52,6.66,37.69,6.66,37.69s20.25-2.41,20.75-10.75S159.44,85.78,159.44,85.78Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.73,72.45c1.81,2.55,11,5.08,18.11,3.76,3.81,20.74-3.25,45.38-3.25,45.38s-18.87-1.68-20-11.59S312.73,72.45,312.73,72.45Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.73,72.45c1.81,2.55,11,5.08,18.11,3.76,3.81,20.74-3.25,45.38-3.25,45.38s-18.87-1.68-20-11.59S312.73,72.45,312.73,72.45Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,252.07h0a1.1,1.1,0,0,1-1.25-.94L155,82.66a1.12,1.12,0,0,1,1-1.26h0a1.11,1.11,0,0,1,1.25.95L181,250.81A1.12,1.12,0,0,1,180,252.07Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,252.07h0a1.1,1.1,0,0,1-1.25-.94L155,82.66a1.12,1.12,0,0,1,1-1.26h0a1.11,1.11,0,0,1,1.25.95L181,250.81A1.12,1.12,0,0,1,180,252.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,239.55h0a1.12,1.12,0,0,0,1.26-1l23.8-168.46a1.11,1.11,0,0,0-.94-1.26h0a1.12,1.12,0,0,0-1.26,1l-23.8,168.46A1.12,1.12,0,0,0,293.17,239.55Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,239.55h0a1.12,1.12,0,0,0,1.26-1l23.8-168.46a1.11,1.11,0,0,0-.94-1.26h0a1.12,1.12,0,0,0-1.26,1l-23.8,168.46A1.12,1.12,0,0,0,293.17,239.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.05,86.22l4.5,33.08a1.46,1.46,0,0,0,1.86,1.21c10.06-2.88,66-17.24,151.93-8.1a1.46,1.46,0,0,0,1.6-1.17c1.62-8.38,4.41-32.25,5.12-38.36a1.48,1.48,0,0,0-1.28-1.63c-11.54-1.46-90.31-10.19-162.72,13.37A1.49,1.49,0,0,0,154.05,86.22Z",
    style: {
      fill: "#28D1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.05,86.22l4.5,33.08a1.46,1.46,0,0,0,1.86,1.21c10.06-2.88,66-17.24,151.93-8.1a1.46,1.46,0,0,0,1.6-1.17c1.62-8.38,4.41-32.25,5.12-38.36a1.48,1.48,0,0,0-1.28-1.63c-11.54-1.46-90.31-10.19-162.72,13.37A1.49,1.49,0,0,0,154.05,86.22Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.48,92l4.74-1,3.35,8.71.85-9.56,4.73-1,4.15,8.54.06-9.39,4.72-1-.62,16.9-4.89,1-4.69-9.62-1,10.76-4.89,1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4,87.12l13.49-2,.44,3.48-8.44,1.24.33,2.6,7.83-1.15.42,3.33-7.83,1.15L200,99l8.69-1.27.47,3.7-13.74,2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.32,84.73l5.06-.55,1.08,12.37,7.89-.85.36,4-13,1.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.06,92.06l4.51,1a8.41,8.41,0,0,1-1.25,3.24A6.32,6.32,0,0,1,238,98.4a9.16,9.16,0,0,1-3.59.9,10.52,10.52,0,0,1-4.41-.47A6.77,6.77,0,0,1,227,96.29a9.21,9.21,0,0,1-1.49-4.94,8.75,8.75,0,0,1,1.84-6.43,8.37,8.37,0,0,1,6-2.63,8.2,8.2,0,0,1,4.93.9,7.24,7.24,0,0,1,2.84,3.68l-4.43,1.32a3.59,3.59,0,0,0-.55-1.07A2.88,2.88,0,0,0,235,86.3a3.22,3.22,0,0,0-4,1.36,6,6,0,0,0-.53,3.3q.13,2.73,1,3.69a2.79,2.79,0,0,0,2.38.85,2.91,2.91,0,0,0,2.16-1A5.26,5.26,0,0,0,237.06,92.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.42,90.15a8.72,8.72,0,0,1,2.16-6.36,8.57,8.57,0,0,1,6.21-2.46,8.46,8.46,0,0,1,6.35,2,8.23,8.23,0,0,1,2.29,6.12,10.28,10.28,0,0,1-.9,4.78,7.15,7.15,0,0,1-2.77,3,9.3,9.3,0,0,1-4.55,1.18,10.27,10.27,0,0,1-4.61-.74,6.73,6.73,0,0,1-3-2.72A9.28,9.28,0,0,1,243.42,90.15Zm5.07-.14a5.49,5.49,0,0,0,1,3.56,3,3,0,0,0,2.52,1,3.18,3.18,0,0,0,2.52-1.15,6.22,6.22,0,0,0,.85-3.87,5,5,0,0,0-1-3.37,3.09,3.09,0,0,0-2.55-1,3.13,3.13,0,0,0-2.45,1.17A5.66,5.66,0,0,0,248.49,90Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.51,81.29l6.67,0,2.3,10.07,2.83-10,6.67.06-.45,16.5-4.16,0,.34-12.59-3.54,12.56-3.76,0-2.85-12.62-.34,12.59-4.16,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.64,81.58l13.57.61L299,85.71l-8.5-.38L290.33,88l7.88.35L298,91.66l-7.88-.35-.2,3.26,8.74.38-.24,3.74-13.82-.62Z",
    style: {
      fill: "#fafafa"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.d218e3a9e75f68827b41cefe2ac6a09b.svg";
export { ForwardRef as ReactComponent };